module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wiskey@3x_154863.jpg";